<ng-container *ngIf= "isOnToolbar">
  <med-button id="myStudies" *ngIf="hasStudyMembership" (click)="onStudySelect()" size="small" color="primary" button-type="flat">
    <mat-icon class="mat-18 mr-5 vam">exit_to_app</mat-icon>
    <span class="vam">{{ 'myStudies' | translate }}</span>
  </med-button>
</ng-container>

